import styled from "styled-components";

export const ContainerBody = styled.div`
  height: 100vh;
  display: grid;
  grid-template-rows: auto;
  background-color: #000000;
  max-width: 1920px;
  margin: auto;
  overflow: hidden;
`;
